<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Ny Auksjon</h4>
      </div>

      <div class="cell shrink" v-if="loading">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>
      <div class="cell shrink" v-else>
        <a href="javascript:;" @click="changeAuctionMode()" class="button primary transparent">{{ objectFilters.sold ? 'Usolgte objekter' : 'Solgte objekter' }}</a>
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" v-if="!finishedAuction" class="button primary">Lagre</a>
      </div>

    </div>

    <TheLoader :active="loading"/>

    <div v-if="!loading" class="content-container flex-row">
      <section class="content large-padding small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="alert error inline-alert active" v-if="objectFilters.sold">
              <div class="alert-wrapper">
              <span class="icon alert-icon error">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-alert-error"></use></svg>
              </span>
                <div class="alert-content">
                  <div class="alert-title">Merk følgende</div>
                  <div class="alert-subtitle">Du oppretter nå en auksjon med solgte objekter, sluttdatoen må være lavere enn i dag</div>
                </div>
              </div>
            </div>
            <div class="grid-x card-grid grid-padding-x">
              <TheTextInput containerClassName="cell medium-6 large-3" label="NettauksjonID" name="NettauksjonID"
                            v-model.trim="$route.params.id" v-if="$route.params.id" :disabled="true"/>
            </div>
            <div class="grid-x card-grid grid-padding-x">
              <TheTextInput containerClassName="cell medium-6 large-3" label="Tittel" name="Tittel"
                            v-model.trim="auction.Navn" required v-validate="'required'"/>
              <TheTextInput v-if="blockDate" containerClassName="cell medium-6 large-3" label="Synlig på nett fra ( DD.MM.YY HH:MM:SS )"
                            name="Starttid" v-model.trim="auction.starttid" required v-validate="'required'" disabled/>
              <TheTextInput v-else containerClassName="cell medium-6 large-3" label="Synlig på nett fra ( DD.MM.YY HH:MM:SS )"
                            name="Starttid" v-model.trim="auction.starttid" required v-validate="'required'"/>

              <div class="cell medium-6 large-3">
                <TheTextInput v-if="blockDate" :label="avdeling != 'klassisk' ? 'Sluttid ( DD.MM.YY HH:MM:SS )' : 'Auksjonsdato (DD.MM.YY HH:MM:SS)'"
                              name="Sluttid" v-model.trim="auction.sluttid" required v-validate="'required'" disabled/>
                <TheTextInput v-else :label="avdeling != 'klassisk' ? 'Sluttid ( DD.MM.YY HH:MM:SS )' : 'Auksjonsdato (DD.MM.YY HH:MM:SS)'"
                              name="Sluttid" v-model.trim="auction.sluttid" required v-validate="'required'" @change="onChangeSlutt"/>
                <div v-show="dateWarningShortTime" style="font-size: .6875rem; font-weight: 600; margin-top: -23px; color: #856404; background-color: #fff3cd; border-color: #ffeeba; text-align: center; padding: 3px; border-radius: 3px;">Auksjonen avsluttes om mindre enn 6 dager</div>
                <div v-show="dateWarningFinished" style="font-size: .6875rem; font-weight: 600; margin-top: -23px; color: #856404; background-color: #fff3cd; border-color: #ffeeba; text-align: center; padding: 3px; border-radius: 3px;">Auksjonen allerede avsluttet</div>
              </div>
              <div class="cell medium-6 large-3">
                <TheNumberInput containerClassName="cell medium-6 large-3" label="Sluttintervall (i sekunder)"
                              name="Sluttintervall" v-model.trim="auction.Sluttintervall" required
                              v-validate="'required'" v-if="avdeling != 'klassisk'" min="0" max="60"  @change="onChangeSluttinterval"/>
                <div v-show="sluttintervallErrorMessage" style="font-size: .6875rem; font-weight: 600; margin-top: -23px; color: #721c24; background-color: #f8d7da; border-color: #f8d7da; text-align: center; padding: 3px; border-radius: 3px;">Verdien må være mindre enn 60</div>
                <TheTextInput containerClassName="cell medium-6 large-3"
                              label="Siste frist for forhåndsbud ( DD.MM.YY HH:MM:SS )" name="Sisteforhandsbud"
                              v-model.trim="auction.Sisteforhandsbud" required v-validate="'required'"
                              v-if="avdeling == 'klassisk'"/>
              </div>
              <TheSelectInput
                containerClassName="cell medium-4 large-2"
                label="Velg kategori"
                name="cat"
                v-model.trim="objectFilters.category"
                :items="kategoriOptions"
              />
              <TheSelectInput
                containerClassName="cell medium-4 large-2"
                label="Sorter på"
                name="sort_by"
                v-model.trim="objectFilters.sort_by"
                :items="sorterOptions"
              />
              <TheSelectInput
                containerClassName="cell medium-4 large-2"
                label="Rekkefølge"
                name="asc_desc"
                v-model.trim="objectFilters.asc_desc"
                :items="ascDescOptions"
              />
              <TheSelectInput
                containerClassName="cell medium-4 large-2"
                label="Limit"
                name="limit"
                v-model.trim="objectFilters.limit"
                :items="limitOptions"
              />
              <TheTextInput
                containerClassName="cell medium-4 large-2"
                label="Objekt" name="Objekt"
                v-model.trim="objectFilters.searchObject"
              />
              <TheSelectInput
                containerClassName="cell medium-4 large-2"
                label="Auksjon"
                name="auksjon"
                v-model.trim="objectFilters.auksjon"
                :items="auksjonOptions"
              />
            </div>
            <div class="grid-x card-grid grid-padding-x">
              <div class="cell medium-8 large-8">
                <div class="grid-x card-grid grid-padding-x">
                  <div class="cell medium-6 large-6">
                    <a href="javascript:;" @click="getObjects()" class="button primary">Oppdater</a>
                  </div>
                  <div class="cell medium-6 large-6" v-if="objectList.length > 0" style="text-align: right;">
                    <a href="javascript:;" @click="addAllObjects(objectList)" class="button primary">Velg alle</a>
                  </div>
                  <div class="cell medium-12 large-12">
                    <table v-if="objectList.length > 0 && !finishedAuction">
                      <thead>
                      <tr>
                        <th>Bilde</th>
                        <th>Tittel</th>
                        <th>Objektnr</th>
                        <th>Ant.g i auk.</th>
                        <th>Siste ute</th>
                        <th>Levert inn av / Kontraktans</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="list-group-item" v-for="(object) in objectList" :key="object.name">
                        <td>
                          <img style="width:85px;" :src="loadImage(object)"/>
                        </td>
                        <td v-html="formatTitle(object)"></td>
                        <td>
                          <a href="javascript:;" @click="loadObjektModal(object.Objektid)">{{ object.Objektnr }}</a> <br/>
                          {{ object.Auksjon }}
                        </td>
                        <td colspan="1">{{ object.antall }}</td>
                        <td v-html="formatDates(object)"></td>
                        <td>{{ object.SelgerNavn }}<br>{{object.Mottaker}}</td>
                        <td>
                          <a href="javascript:;" @click="addObject(object)">
                            <svg width="16px" height="16px" viewBox="0 0 16 16">
                              <use xlink:href="/static/sprites.svg#button-glyph-add"></use>
                            </svg>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <p v-if="!finishedAuction">Ingen gjenstander funnet</p>
                      <p v-else>Denne auksjonen er allerede avsluttet, og du kan ikke legge til objekter</p>
                    </div>
                    <div class="pagination-container" v-if="pageCount > 1 && !finishedAuction" style="margin-top: 3rem;">
                      <paginate v-model="currentPage"
                                :page-count="pageCount"
                                :page-range="11"
                                :click-handler="changePage"
                                :container-class="'pagination'"
                                :prev-text="paginationArrow"
                                :next-text="paginationArrow"
                                :prev-class="'prev'"
                                :next-class="'next'"
                      >
                      </paginate>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell medium-4 large-4">
                <div class="grid-x card-grid grid-padding-x">
                  <div class="cell medium-12 large-12" v-if="this.$route.params.avdeling == 'vin' && !this.$route.params.id">
                    <input ref="csv" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden @change="onCsvSelected">
                    <a href="javascript:;" @click="uploadCsv()" class="button primary">Last opp objekter</a>
                  </div>
                  <div class="cell medium-offset-12 large-offset-12">
                    &nbsp;<br>
                  </div>
                  <div class="cell medium-12 large-12">
                    <label v-if="objectsInAuction.length > 0">Antall objekter: <b>{{ objectsInAuctionPagination.totalObjects }}</b></label>
                    <table v-if="objectsInAuction.length > 0">
                      <thead>
                      <tr>
                        <th></th>
                        <th>Tittel</th>
                        <th>Objektnr</th>
                        <th></th>
                      </tr>
                      </thead>
                        <draggable tag="tbody" class="list-group" :list="objectsInAuction" group="objects" v-if="!this.$route.params.id" @change="onChangeOrder">
                          <tr class="list-group-item" v-for="(element) in objectsInAuction" :key="element.name">
                            <td>
                              <img style="width:85px;" :src="loadImage( element)" />
                            </td>
                            <td v-html="formatTitle( element)"></td>
                            <td><a href="javascript:;" @click="loadObjektModal(element.Objektid)">{{ element.Objektnr }}</a><br>{{element.Auksjon}}</td>
                            <td>
                              <a href="javascript:;" @click="verifyBidsHistory(element)">
                                <svg width="16px" height="16px" viewBox="0 0 16 16">
                                  <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                                </svg>
                              </a>
                            </td>
                          </tr>
                        </draggable>
                      <tbody v-else>
                        <tr class="list-group-item" v-for="(element) in objectsInAuction" :key="element.name">
                          <td>
                            <img style="width:85px;" :src="loadImage( element)" />
                          </td>
                          <td v-html="formatTitle( element)"></td>
                          <td><a href="javascript:;" @click="loadObjektModal(element.Objektid)">{{ element.Objektnr }}</a><br>{{element.Auksjon}}</td>
                          <td>
                            <a href="javascript:;" @click="verifyBidsHistory(element)">
                              <svg width="16px" height="16px" viewBox="0 0 16 16">
                                <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                              </svg>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <p>Ingen gjenstander funnet</p>
                    </div>
                    <div class="pagination-container" v-if="objectsInAuctionPagination.pageCount > 1" style="margin-top: 3rem;">
                      <paginate v-model="objectsInAuctionPagination.currentPage"
                                :page-count="objectsInAuctionPagination.pageCount"
                                :page-range="6"
                                :click-handler="changePageObjectsInAuction"
                                :container-class="'pagination'"
                                :prev-text="paginationArrow"
                                :next-text="paginationArrow"
                                :prev-class="'prev'"
                                :next-class="'next'"
                      >
                      </paginate>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
    <div class="modal-container" :class="{'active': deleteConfirmActive}">
      <div class="modal-window" :class="{'active': deleteConfirmActive}">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Ønsker du å fjerne dette objektet?</h3>
          </div>
        </div>
        <div class="modal-window-body gray" style="overflow-y: scroll;">
          <table v-if="objectList.length > 0">
            <thead>
            <tr>
              <th>Kundenummer</th>
              <th>Navn</th>
              <th>Email</th>
            </tr>
            </thead>
            <tbody>
            <tr class="list-group-item" v-for="(objectBids) in listObjectBids" :key="objectBids.customerNumber">
              <td><i>{{ objectBids.customerNumber }}</i></td>
              <td>{{ objectBids.name }}</td>
              <td>{{ objectBids.email }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button href="javascript:;" class="button primary submit" @click="removeObject(selectedObjectDelete)">
                <span>Fjern objekt</span>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="deleteConfirmActive = false">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="deleteConfirmActive" class="modal-overlay" @click="deleteConfirmActive = false"></div>
    </div>

    <div class="modal-container" :class="{'active': deleteConfirmActiveNotBids}">
      <div class="modal-window" :class="{'active': deleteConfirmActiveNotBids}" style="min-height: 100px !important;">
        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3>Ønsker du å fjerne dette objektet?</h3>
          </div>
        </div>
        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <button href="javascript:;" class="button primary submit" @click="removeObject(selectedObjectDelete)">
                <span>Fjern objekt</span>
              </button>
            </div>
          </div>
        </div>
        <a href="javascript:;" class="modal-close modal-window-close-button" @click="deleteConfirmActiveNotBids = false">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </div>
      <div v-if="deleteConfirmActiveNotBids" class="modal-overlay" @click="deleteConfirmActiveNotBids = false"></div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'
import BrukerService from '@/services/BrukerService'
import MiscService from '@/services/MiscService'
import NettAuksjonService from '@/services/NettAuksjonService'
import AuksjonService from '@/services/AuksjonService'
import TheNumberInput from '../../../Inputs/TheNumberInput.vue'

let start = moment().add(1, 'days').locale('nb')
let end = moment().add(10, 'days').locale('nb')

export default {
  name: 'AuksjonForm',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return this.initialState()
  },
  created () {
    this.loadFilters()

    const edit = !!this.$route.params.id

    if (edit) {
      this.loadAuction(this.$route.params.id)
    }

    this.getObjects()
  },
  components: {
    TheNumberInput,
    draggable
  },
  methods: {
    initialState () {
      // Classic: 0; Online: 1; Wine: 2
      let avdeling = this.$route.params.avdeling
      let avdelingsid

      switch (this.$route.params.avdeling) {
        case 'vin':
          avdelingsid = 2
          break
        case 'nett':
          avdelingsid = 1
          break
        default:
          avdelingsid = 0
      }

      return {
        avdeling: avdeling,
        auction: {
          Avdelingsid: avdelingsid,
          Navn: `${start.format('DD.MM')} - ${end.format('DD.MM')}`,
          starttid: start.format('dddd, DD.MM.Y 09:00:00'),
          sluttid: end.format('dddd, DD.MM.Y 20:00:00'),
          Sluttintervall: avdeling !== 'klassisk' ? 30 : null,
          Sisteforhandsbud: avdeling === 'klassisk' ? end.format('DD.MM.Y 20:00:00') : null,
          HBVersion: 1
        },
        objectList: [],
        objectsInAuction: [],
        objectsInAuctionIds: [],
        objectsInAuctionPagination: {
          currentPage: 1,
          pageCount: 1,
          totalObjects: 0,
          limit: 200
        },
        auksjonOptions: [],
        currentPage: 1,
        pageCount: 1,
        kategoriOptions: [
          {key: 'endretAvSelgerIkkeProvd', val: 'Objekter endret av selger, ikke forsøkt'},
          {key: 'endretAvSelger', val: 'Objekter endret av selger'},
          {key: 'all', val: 'Alle'},
          {key: 'group_art', val: 'Kunst'},
          {key: 'group_books_and_maps', val: 'Bøker, Kart'},
          {key: 'group_other', val: 'Øvrige objekter'}
        ],
        sorterOptions: [
          {key: '', val: 'Sorter på'},
          {key: 'antall', val: 'Ganger i auksjon'},
          {key: 'Mottaker', val: 'Kontraktansv'},
          {key: 'SistUteSlutt', val: 'Sist ute'},
          {key: 'Endret_av_selger', val: 'Dato endret av selger'}
        ],
        ascDescOptions: [
          {key: '', val: 'Rekkefølge'},
          {key: 'ASC', val: 'Økende'},
          {key: 'DESC', val: 'Minkende'}
        ],
        limitOptions: [
          {key: 100, val: 'Vis 100 pr.side'},
          {key: 250, val: 'Vis 250 pr.side'},
          {key: 500, val: 'Vis 500 pr.side'}
        ],
        brukerOptions: [],
        objectFilters: {
          page: 1,
          limit: 100,
          avdelingsid: avdelingsid,
          exclude: [],
          sold: 0
        },
        deleteConfirmActive: false,
        deleteConfirmActiveNotBids: false,
        selectedObjectDelete: [],
        listObjectBids: [],
        loading: true,
        blockDate: false,
        finishedAuction: false,
        csv: null,
        csvLoaded: false,
        dateWarningShortTime: false,
        dateWarningFinished: false,
        sluttintervallErrorMessage: false
      }
    },
    reset () {
      const edit = !!this.$route.params.id

      if (!edit) {
        this.auction = this.initialState().auction
        this.objectList = this.initialState().objectList
        this.objectsInAuction = this.initialState().objectsInAuction
        this.currentPage = this.initialState().currentPage
        this.pageCount = this.initialState().pageCount
        this.objectFilters = this.initialState().objectFilters
      }
    },
    loadAuction: function (id, page = 1) {
      this.loading = true

      let withObject = localStorage[`auction_${this.$route.params.avdeling}_filter`]
      NettAuksjonService.getAuction(id, withObject !== 'noobjects', page)
        .then((response) => {
          this.auction.Avdelingsid = response.data.Avdelingsid
          this.auction.Navn = response.data.Navn
          this.auction.starttid = response.data.Start
          this.auction.sluttid = response.data.Slutt
          this.auction.Sluttintervall = response.data.Sluttintervall
          this.auction.HBVersion = response.data.HBVersion
          this.auction.Sisteforhandsbud = response.data.Sisteforhandsbud

          this.auction.starttid = this.formatDateMoment(this.auction.starttid, false)
          this.auction.sluttid = this.formatDateMoment(this.auction.sluttid, false)

          if (withObject !== 'noobjects') {
            if (this.objectsInAuctionIds.length === 0) {
              this.objectsInAuctionIds = response.data.objectIds
            }
            this.objectsInAuction = response.data.objects.map(object => {
              if (object.Salgspris > 0) {
                this.objectFilters.sold = true
              }
              return {
                ...object.objekt,
                antall: object.objekt.Antall,
                SistUteStart: object.Start,
                SistUteSlutt: object.Slutt,
                Mottaker: object.objekt.kontrakt.Mottaker,
                SelgerNavn: object.objekt.innlevav.Fnavn + ' ' + object.objekt.innlevav.Enavn,
                thumb: object.thumb || ''
              }
            })
            this.objectsInAuctionPagination.pageCount = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
            this.objectsInAuctionPagination.totalObjects = parseInt(response.headers['x-paging-count'] || 1)
          }

          this.checkStartDate(this.auction.starttid, this.auction.sluttid)

          if (this.auction.Sluttintervall > 60) {
            this.sluttintervallErrorMessage = true
          }

          this.loading = false
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke hente auksjoner')
            this.loading = false
          }
        })
    },
    formatTitle: function (element) {
      let title = ''
      let navn = element.Navn && element.Navn.split(',')

      if (element.Kunstnerid > 1) {
        if (navn) {
          title += navn.length > 1 ? `${navn[1]} ${navn[0]}` : navn[0]
        }

        if (element.Katalogtekst1) {
          title += ` / ${element.Katalogtekst1} <br />`
        }

        if (element.Objekt3) {
          title += `${element.Objekt3} <br />`
        }

        if (element.Objekt1) {
          title += `${element.Objekt1} <br />`
        }
      } else {
        title += element.Kunstner ? element.Kunstner : element.Katalogtekst1
        title += '<br />'
      }

      if (element.objektNotat) {
        if (element.objektNotat.length > 0) {
          title += '<span style="background-color: yellow; padding: 2px;">Objektnotat</span> &nbsp;'
        }
      }

      if (element.times_price_change > 0) {
        title += '<span style="background-color: #4758A6; padding: 2px; color: white;">Minstepris nedsatt</span>'
      }

      if (element.Nettmerknad) {
        if (element.Nettmerknad.length > 0) {
          title += '<span style="background-color: yellow; padding: 2px;">Merknad</span>'
        }
      }

      if (element.Salgspris > 0) {
        title += '<div style="background-color: red; color: white; font-weight: bold; padding: 2px; text-align: center;">Objektet er allerede solgt</div>'
      }

      return title
    },
    formatDates: function (element) {
      let end = moment(element.SistUteSlutt).format('DD.MMM YYYY')

      return `${end}`
    },
    loadImage: function (object) {
      return object.thumb || ''
    },
    loadFilters: function () {
      MiscService.loadDropdownKategori({avdeling: this.auction.Avdelingsid})
        .then((data) => {
          this.kategoriOptions = [
            {key: '', val: 'Velg kategori'},
            ...data
          ]
        })

      var tilpassetHvor = [
        {'hvor': 'LEFT(Auksjon, 2) !=', 'param': 'AR'},
        {'hvor': 'LEFT(Auksjon, 2) !=', 'param': 'LY'},
        {'hvor': 'LEFT(Auksjon, 4) !=', 'param': 'SEUH'},
        {'hvor': 'LEFT(Auksjon, 4) !=', 'param': 'VENT'}
      ]

      var rekkefolge = {'rekkefolge': 'Auksjonsid', 'retning': 'DESC'}

      AuksjonService.dropdown('Auksjon', null, this.auction.Avdelingsid, JSON.stringify(tilpassetHvor), JSON.stringify(rekkefolge), !this.objectFilters.sold)
        .then(data => {
          this.auksjonOptions = [
            {key: '', val: 'Auksjon'},
            ...data.data
          ]
        })

      BrukerService.dropdown('Brukernavn', 1)
        .then(data => {
          this.brukerOptions = [
            {key: '', val: 'Bruker'},
            ...data.data
          ]
        })
    },
    handleSubmit: function () {
      this.loading = true
      if (!this.isFormSubmittable()) {
        this.loading = false
        return
      }
      if (this.auction.Sluttintervall > 60) {
        this.loading = false
        this.sluttintervallErrorMessage = true
        this.$helpers.showErrorAlert('', 'Verdien må være mindre enn 60')
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
            this.loading = false
          } else {
            let data = this._.clone(this.auction)

            if (this.objectFilters.sold) {
              const endDate = moment(this.formatDateMoment(data.sluttid, true), ' DD.MM.YYYY HH:mm:ss').locale('nb')
              const now = moment()
              if (endDate.isAfter(now)) {
                this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Sluttdatoen må være lavere enn i dag')
                this.loading = false
                return
              }
            }

            data.starttid = this.formatDateMoment(data.starttid, true)
            data.sluttid = this.formatDateMoment(data.sluttid, true)
            data = {...data, objects: this.objectsInAuctionIds.map(objectId => objectId)}
            NettAuksjonService.save(this.$route.params.id, data)
              .then((response) => {
                this.$helpers.showSuccessAlert(`Auksjon ${response.data.NettauksjonsID} er lagret`)
                this.onCancel()
                this.loading = false
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.errors.items.forEach((error) => {
                    this.$helpers.showErrorAlert('Feil', error.msg, false, 5000)
                  })
                  this.$validator.resume()
                }
                this.loading = false
              })
          }
        })
    },
    getObjects: function () {
      this.loading = true

      NettAuksjonService.getObjects(this.objectFilters)
        .then((response) => {
          this.objectList = response.data.objects
          this.pageCount = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.loading = false
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke hente auksjoner')
          }
          this.loading = false
        })
    },
    addObject: function (object) {
      this.objectList = this.objectList.filter(function (obj) {
        return obj.Objektid !== object.Objektid
      })
      if (!this.objectFilters.exclude.includes(object.Objektid)) {
        this.objectFilters.exclude.push(object.Objektid)
      }
      if (!this.objectsInAuction.includes(object)) {
        this.objectsInAuction.push(object)
      }
      if (!this.objectsInAuctionIds.includes(object.Objektid)) {
        this.objectsInAuctionIds.push(object.Objektid)
      }
      this.objectsInAuctionPagination.totalObjects = this.objectsInAuctionPagination.totalObjects + 1

      if (!this.$route.params.id && this.csvLoaded) {
        this.loading = true
        NettAuksjonService.csvAddObject({
          Objektnr: object.Objektnr,
          Avdelingsid: this.auction.Avdelingsid,
          index: this.objectsInAuction.length - 1,
          page: this.objectsInAuctionPagination.currentPage,
          limit: this.objectsInAuctionPagination.limit
        }).catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke legge til objekt')
          this.removeObject(object)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    addAllObjects: function (objects) {
      for (let i = 0; i < objects.length; i = i + 1) {
        this.objectList = this.objectList.filter(function (obj) {
          return obj.Objektid !== objects[i].Objektid
        })
        this.objectFilters.exclude.push(objects[i].Objektid)
        this.objectsInAuction.push(objects[i])
        this.objectsInAuctionIds.push(objects[i].Objektid)
        this.objectsInAuctionPagination.totalObjects = this.objectsInAuctionPagination.totalObjects + 1
      }
      this.getObjects()
    },
    removeObject: function (object) {
      this.objectsInAuction = this.objectsInAuction.filter(function (obj) {
        return obj.Objektid !== object.Objektid
      })
      this.objectsInAuctionIds = this.objectsInAuctionIds.filter(function (objectId) {
        return objectId !== object.Objektid
      })
      this.objectFilters.exclude = this.objectFilters.exclude.filter(function (obj) {
        return obj !== object.Objektid
      })
      this.objectList.push(object)
      this.deleteConfirmActive = false
      this.deleteConfirmActiveNotBids = false
      this.objectsInAuctionPagination.totalObjects = this.objectsInAuctionPagination.totalObjects - 1

      if (!this.$route.params.id && this.csvLoaded) {
        this.loading = true
        NettAuksjonService.csvRemoveObject({
          Objektnr: object.Objektnr,
          Avdelingsid: this.auction.Avdelingsid
        }).catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke fjerne objektet')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        vm.objectFilters.page = page
        vm.getObjects()
      })
    },
    changePageObjectsInAuction: function (page) {
      var vm = this
      var auctionId = this.$route.params.id
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        if (auctionId) {
          vm.loadAuction(auctionId, page)
        } else {
          vm.onCsvSelected(null, page)
        }
      })
    },
    onCancel: function () {
      this.$store.dispatch('nettauksjon/loadAuctionList', this.avdeling)
      this.reset()
      this.$router.go(-1)
    },
    verifyBidsHistory: function (object) {
      AuksjonService.bidHistory(object.Objektid, object.Auksjon)
        .then(data => {
          this.listObjectBids = data.data.data
          this.selectedObjectDelete = object
          if (this.listObjectBids.length < 1) {
            this.deleteConfirmActiveNotBids = true
          } else {
            this.deleteConfirmActive = true
          }
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil under henting av kundeliste')
          this.deleteConfirmActive = false
          this.deleteConfirmActiveNotBids = false
        })
    },
    checkStartDate: function (start, end) {
      if (localStorage[`auction_${this.$route.params.avdeling}_filter`] === 'noobjects') {
        return
      }

      start = moment(start, 'DD.MM.YYYY HH:mm:ss')
      end = moment(end, 'DD.MM.YYYY HH:mm:ss')
      let now = moment()
      if (now.isAfter(start) && this.objectsInAuction.length > 0) {
        this.blockDate = true
      }

      if (now.isAfter(end)) {
        this.finishedAuction = true
      }
    },
    formatDateMoment: function (date, reverse) {
      let momentObj = ''
      let momentString = ''
      if (reverse) {
        momentString = date.split(',')
        momentString = momentString[1]
      } else {
        momentObj = moment(date, 'YYYY-MM-DD HH:mm:ss').locale('nb')
        momentString = momentObj.format('dddd, DD.MM.YYYY HH:mm:ss')
      }
      return momentString
    },
    changeAuctionMode () {
      this.objectFilters.sold = !this.objectFilters.sold
      if (this.objectFilters.sold) {
        this.auction.starttid = moment().subtract(10, 'days').locale('nb').format('dddd, DD.MM.Y 09:00:00')
        this.auction.sluttid = moment().subtract(1, 'days').locale('nb').format('dddd, DD.MM.Y 20:00:00')
      } else {
        this.auction.starttid = moment().add(1, 'days').locale('nb').format('dddd, DD.MM.Y 09:00:00')
        this.auction.sluttid = moment().add(10, 'days').locale('nb').format('dddd, DD.MM.Y 20:00:00')
      }

      this.objectFilters.auksjon = null
      this.objectList = []
      this.objectsInAuction = []
      this.objectsInAuctionIds = []
      this.getObjects()
      this.loadFilters()
    },
    uploadCsv: function () {
      this.$refs.csv.click()
    },
    onCsvSelected: async function (e, page = 1) {
      this.loading = true

      const formData = new FormData()

      if (e && e.target.files) {
        this.csv = e.target.files[0]
        formData.append('upload', true)
      }
      formData.append('page', page)
      formData.append('limit', this.objectsInAuctionPagination.limit)
      formData.append('avdelingsid', this.auction.Avdelingsid)
      formData.append('file', this.csv)
      NettAuksjonService.getObjects(null, formData)
        .then((response) => {
          this.objectsInAuction = response.data.objects
          this.objectsInAuctionPagination.pageCount = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.objectsInAuctionPagination.totalObjects = parseInt(response.headers['x-paging-count'] || 0)
          if (response.data.csv && response.data.csv.missingObjectNrs.length > 0) {
            this.$helpers.showErrorAlert('Kan ikke legge til objekter', response.data.csv.missingObjectNrs.join(', '))
          }
          let csvObjectIds = []
          if (response.data.csv && response.data.csv.objectIds.length > 0) {
            csvObjectIds = response.data.csv.objectIds
          }
          this.objectsInAuctionIds = csvObjectIds
          this.objectFilters.exclude = csvObjectIds
          this.getObjects()
          this.loading = false
          this.csvLoaded = true
        })
        .catch((error) => {
          // Put API errors into the error container
          this.$helpers.sendApiErrorsToValidator(error, this.errors)

          // Check if new errors appeared
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke laste opp objekter')
          }
          this.loading = false
        })
    },
    onChangeOrder: function (object) {
      if (!this.$route.params.id && this.csvLoaded) {
        this.loading = true
        if (object.moved.oldIndex >= 0 && object.moved.oldIndex < this.objectsInAuctionIds.length && object.moved.newIndex >= 0 && object.moved.newIndex < this.objectsInAuctionIds.length) {
          const element = this.objectsInAuctionIds.splice(object.moved.oldIndex, 1)[0]
          this.objectsInAuctionIds.splice(object.moved.newIndex, 0, element)
        }

        NettAuksjonService.csvChangeOrder({
          Objektnr: object.moved.element.Objektnr,
          Avdelingsid: this.auction.Avdelingsid,
          newIndex: object.moved.newIndex,
          oldIndex: object.moved.oldIndex,
          page: this.objectsInAuctionPagination.currentPage,
          limit: this.objectsInAuctionPagination.limit
        }).catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke legge til objekt')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    onChangeSlutt: function () {
      let clearDate = this.formatDateMoment(this.auction.sluttid, true)
      let momentDate = moment(clearDate, 'DD-MM-YYYY HH:mm:ss').locale('nb')
      let now = moment()
      let diffDays = momentDate.diff(now, 'days')
      this.dateWarningShortTime = false
      this.dateWarningFinished = false

      if (diffDays < 0) {
        this.dateWarningShortTime = false
        this.dateWarningFinished = true
      } else if (diffDays <= 6) {
        this.dateWarningShortTime = true
        this.dateWarningFinished = false
      }
    },
    onChangeSluttinterval: function () {
      this.sluttintervallErrorMessage = false
      if (this.auction.Sluttintervall > 60) {
        this.sluttintervallErrorMessage = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Auksjon/AuksjonForm.vue